export default __webpack_public_path__ + "static/media/omnione_logo_light.e42c2191.svg";